// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22F6N","question":"styles_question__2-S8j","description":"styles_description__5ENHI"};